import { useEffect, useMemo, useState } from "react";
import { js_utils } from "../utils/frfr-js-utils";
import { pagination_utils } from "../utils/frfr-pagination-utils";


/*
TODO
cl_blu_containerExtraClass
cl_blu_tableExtraClass

TODO na seleced shanged CALLBACK popuniti sve rorwoove u koliko je izabrano select all
srediti da selektuje samo vidljive rows.

TODO srediti da nakon klika na unselect row pravilno radi


novaDefinicija = _kreirajDefincijuTabeleIzObjekta(tableRowObj, sema);

key extractor for mapCb
*/

let _counter_global = 0;

//
const _TableGenerator_default_cellBlu = {
  sortable: true,
  filterable: true,
  searchable: true, // TODO
};
const _TableGenerator_default_blueprint_row = {
  rowKeyExtractorCb: (row, row_index) => {
    // return row_index;
    return row?.id; // default row key is 'id'
  },
};
const _TableGenerator_default_blueprint_table = {
  showFilterRow: true, // TODO
  showSelectable: true, // TODO
  showSelectableSingular: false, // default false
  showSelectAll: true, // default true
};
const _TableGenerator_default_blueprint_general = {
  // disableBlueprintCaching // TODO
  selectAllSelectOnlyVisible: true, // TODO
  showPagination: true, // TODO
  perPageInital: 10, // TODO
};
//
const _fix_cellBlueprint = (_cellBlu, col_index, defaultColumnBlueprint) => {
  if (typeof _cellBlu === 'string') {
    return {
      ..._TableGenerator_default_cellBlu,
      ...defaultColumnBlueprint,
      key: _cellBlu, // TODO
      title: _cellBlu,
    };
  } else {
    // return _cellBlu;
    return {
      ..._TableGenerator_default_cellBlu,
      ...defaultColumnBlueprint,
      ..._cellBlu,
    };
  }
};
//
const _fix_tableBlueprint = (tableBlueprint) => {
  console.log('_fix_tableBlueprint ...');
  let blueprintError = null;
  let fixed = {
    freshness: null,
    general: {
    },
    table: {
    },
    defaultColumnBlueprint: {},
    columns: [],
    row: {
    },
  };
  /*
  // example blueprintRow
  let blueprintRow_example = {
    cbRow: (row) => { },
    extraClass: 'extra-tr-class',
    // TODO
  };
  */
  if (js_utils.is_object(tableBlueprint)) {
    //
    if ('freshness' in tableBlueprint) {
      fixed.freshness = tableBlueprint.freshness;
    }
    //
    // let blueprintGeneral = {};
    if (js_utils.is_object(tableBlueprint?.general)) {
      fixed.general = tableBlueprint.general;
      fixed.general = {
        ..._TableGenerator_default_blueprint_general,
        ...tableBlueprint.general,
      };
    }
    //
    // let blueprintTable = {};
    // if (js_utils.is_object(props.blueprintTable)) {
    if (js_utils.is_object(tableBlueprint?.table)) {
      // blueprintTable = props.blueprintTable;
      fixed.table = tableBlueprint.table;
      fixed.table = {
        ..._TableGenerator_default_blueprint_table,
        ...tableBlueprint.table,
      };
    }
    //
    //
    // let defaultColumnBlueprint = {};
    if (js_utils.is_object(tableBlueprint?.defaultColumnBlueprint)) {
      fixed.defaultColumnBlueprint = tableBlueprint.defaultColumnBlueprint;
    }
    // let blueprintColumns = [];
    if (Array.isArray(tableBlueprint?.columns)) {
      fixed.columns = tableBlueprint.columns;
      fixed.columns = fixed.columns.map((_cellBlu, col_index) => {
        return _fix_cellBlueprint(_cellBlu, col_index, fixed.defaultColumnBlueprint);
      });
    }
    //
    //
    // let blueprintRow = {};
    // if (js_utils.is_object(props.blueprintRow)) {
    if (js_utils.is_object(tableBlueprint?.row)) {
      // blueprintRow = props.blueprintRow;
      fixed.row = tableBlueprint.row;
      fixed.row = {
        ..._TableGenerator_default_blueprint_row,
        ...tableBlueprint.row,
      };
    }
    //
    //
    if (fixed.columns.length === 0) {
      blueprintError = 'ERROR tableBlueprint.columns has no items';
    }
    //
  } else {
    blueprintError = 'ERROR invalid tableBlueprint';
  }
  return [fixed, blueprintError];
};


//
export const useTableGenerator = (_fetching, _tableBlueprint, rowsData, cbOnSelectionChange, cbOnSelectionChangeSingular) => {
  // const [sortedColumnKey, setSortKey] = useState(null);
  // ----- state
  const [state, setState] = useState({
    sortingState: {},
    sortedColumnKey: null,
    filteredColumns: {},
    showMore: false, // expand/show more columns
    selectedRowKeys: [],
    selectedAllRows: null, // null or true (all selected) or false (none selected)
    selectedRowSingularKey: false, // false or row_key
    // columnWidthState: {},
    // perPage: '', // TODO
    perPage: 10, // TODO
    pageNo: 1,
  });
  // const [sortingState, setSortingState] = useState({});
  // const [filteredColumns, setFilteredColumns] = useState({});
  // const [showMore, setShowMore] = useState(false); // expand/show more columns
  // const sortedColumnKey = sortingState.__sortByThisKey__;
  const {
    sortingState,
    sortedColumnKey,
    filteredColumns,
    showMore,
    selectedRowKeys,
    selectedAllRows,
    selectedRowSingularKey,
    // columnWidthState,
    // perPage,
    pageNo,
  } = state;
  let perPage = '';
  if (state.perPage > 0) {
    perPage = state.perPage;
  }


  //
  const _handleClick_th_sort = (key) => {
    /*
    let ascending = true;
    if (sortingState[key] && sortingState[key].asc === true) {
      ascending = false;
    }
    setSortingState({
      ...sortingState,
      __sortByThisKey__: key,
      [key]: {
        asc: ascending
      }
    });
    */
    setState(state => {
      let ascending = true;
      if (sortingState[key] && sortingState[key].asc === true) {
        ascending = false;
      }
      return {
        ...state,
        sortedColumnKey: key,
        sortingState: {
          ...state.sortingState,
          [key]: {
            asc: ascending
          }
        }

      };
    });
  };


  //
  const _handleChangeColumnFilterString = (column_key, q) => {
    // let _q = false;
    setState(state => {
      if (typeof q === 'string' && q !== '') { // CASE entered string
        if (state.filteredColumns[column_key] !== q) {
          /*
          setFilteredColumns({
            ...filteredColumns,
            [column_key]: q
          });
          */
          return {
            ...state,
            filteredColumns: {
              ...state.filteredColumns,
              [column_key]: q
            },
            selectedAllRows: null, // also reset selectedAllRows
            pageNo: 1, // also reset pageNo
          };
        }
      } else { // CASE entered empty
        if (state.filteredColumns[column_key] !== false) {
          /*
          setFilteredColumns({
            ...filteredColumns,
            [column_key]: false
          });
          */
          /*
          return {
            ...state,
            filteredColumns: {
              ...state.filteredColumns,
              [column_key]: false
            }
          };
          */
          const updated_filteredColumns_cleaned = {
            ...state.filteredColumns,
            [column_key]: false
          };
          delete updated_filteredColumns_cleaned[column_key]; // CLEANUP
          return {
            ...state,
            filteredColumns: updated_filteredColumns_cleaned,
            selectedAllRows: null, // also reset selectedAllRows
            pageNo: 1, // also reset pageNo
          };
        }
      }
      //

    });
  };


  // ----- BLUEPRINT EXTRACT AND FIX

  // let blueprintError = null;
  const [tableBlueprint, blueprintError] = _fix_tableBlueprint(_tableBlueprint);
  /*
  const _tableBlueprint_freshnes = _tableBlueprint?.freshness;
  const _tableBlueprint_disableBlueprintCaching = _tableBlueprint?.general?.disableBlueprintCaching;
  let _freshness_2 = 0;
  if (_tableBlueprint_disableBlueprintCaching === true) {
    _counter_global++;
    _freshness_2 = _counter_global;
  }
  const { tableBlueprint, blueprintError } = useMemo(
    () => {
      // blueprint caching
      const [tableBlueprint, blueprintError] = _fix_tableBlueprint(_tableBlueprint);
      return { tableBlueprint, blueprintError };
    },
    [_tableBlueprint_freshnes, _freshness_2]
  );
  */
  //
  const blueprintGeneral = tableBlueprint.general;
  const blueprintTable = tableBlueprint.table;
  const blueprintColumns = tableBlueprint.columns;
  const defaultColumnBlueprint = tableBlueprint.defaultColumnBlueprint;
  const blueprintRow = tableBlueprint.row;
  /*
  //
  let blueprintGeneral = {};
  if (js_utils.is_object(tableBlueprint?.general)) {
  }
  //
  let blueprintTable = {};
  // if (js_utils.is_object(props.blueprintTable)) {
  if (js_utils.is_object(tableBlueprint?.table)) {
    // blueprintTable = props.blueprintTable;
  }
  //
  let blueprintColumns = [];
  if (Array.isArray(tableBlueprint?.columns)) {
  }
  //
  let defaultColumnBlueprint = {};
  if (js_utils.is_object(tableBlueprint?.defaultColumnBlueprint)) {
  }
  let blueprintRow = {};
  // if (js_utils.is_object(props.blueprintRow)) {
  if (js_utils.is_object(tableBlueprint?.row)) {
    // blueprintRow = props.blueprintRow;
  }
  */



  // ----- EXPAND MORE COLUMNS

  // NOVO 2022
  const _handleClickShowMoreColumns = (e) => {
    // setShowMore(true);
    setState(state => {
      return {
        ...state,
        showMore: true
      }
    });
  };
  //
  let _cols_before_more = 0;
  if (blueprintTable && blueprintTable.numberOfColumnsBeforeMore && blueprintTable.numberOfColumnsBeforeMore > 0) {
    _cols_before_more = blueprintTable.numberOfColumnsBeforeMore;
  }
  //
  const _isColumnRendered = (col_index) => {
    if (showMore !== true && _cols_before_more > 0) { // SPECIAL MORE SECTION COLLAPSED
      const no = col_index + 1;
      if (no > _cols_before_more) { // CASE CELL IN SPECIAL MORE SECTION WHEN COLLAPSED
        return false; // not render this cell
      } else { // CASE in always display section 
        return true; // render this cell
      }
    }
    // CASE render all columns
    return true;
  };
  //
  const _is_column_index_first_in_special_more_section = (col_index) => {
    if (showMore !== true && _cols_before_more > 0) { // CASE SPECIAL MORE SECTION COLLAPSED
      const no = col_index + 1;
      if ((no - _cols_before_more) === 1) { // CASE BINGO! FIRST CELL IN SPECIAL MORE SECTION WHEN COLLAPSED
        return true; // BINGO!
      }
    }
    // CASE other cell
    return false; // other cell
  };


  // ---------- DATA PREPARING

  //
  let dataError = null;
  let initialRowsData = []; // rows data before filtering, sorting...
  let fetching = false;
  // let jsxSpinner = null;
  if (_fetching === true) {
    // jsxSpinner
    fetching = true;
    /*
    if (props.jsxSpinner) {
      jsxSpinner = props.jsxSpinner;
    } else {
      jsxSpinner = <div className="frfr-table-generator__msg-please-wait">Please wait...</div>
    }
    */
  } else {
    if (Array.isArray(rowsData)) {
      initialRowsData = rowsData;
    } else {
      dataError = 'ERROR rowsData is not Array!';
    }
  }


  // ----- FILTERING
  let filteredData = initialRowsData; // filtered rows are also visible rows
  if (true) {
    const rows_filtered = initialRowsData.filter((row_obj) => {
      let exclude_me = false; // in case there is no filters at all
      let filtered_columns = filteredColumns;
      let filtered_keys = Object.keys(filtered_columns);
      filtered_keys.forEach((k) => {
        let include_me = false;
        let is_value_searchable = false;
        if (typeof row_obj[k] === 'string' || js_utils.is_number(row_obj[k])) {
          is_value_searchable = true;
        }
        const q = filtered_columns[k];
        if (typeof q === 'string' && q !== '') {
          // there is a filter
          console.log('filter');
          if (is_value_searchable) {
            if (q === '*') {
              if (row_obj[k] === '' || row_obj[k] === null) {
                // not include
              } else {
                // include * everything except null or empty sting
                include_me = true;
              }
            } else {
              if (row_obj[k].toString().toUpperCase().indexOf(q.toString().toUpperCase()) > -1) {
                include_me = true;
              } else {
                // not include
              }
            }
          }
        } else {
          // there is no filter, always include
          include_me = true;
        }
        if (include_me === false) {
          exclude_me = true;
        }
      });
      if (exclude_me) {
        return false;
      }
      return true;
    });
    filteredData = rows_filtered;
  }

  // ----- VISIBLE ROWS
  // const visibleRowsData = filteredData; // filtered rows are also visible rows


  // ----- SORTING
  // let sortedData = initialRowsData;
  let sortedData = filteredData;
  if (typeof sortedColumnKey === 'string' && sortedColumnKey !== '') {
    // sortedData = initialRowsData.sort((a, b) => {
    sortedData = filteredData.sort((a, b) => {
      let order = 0;
      order = js_utils.compare_a_b_smart(a[sortedColumnKey], b[sortedColumnKey]); // ascending 
      if (sortingState[sortedColumnKey].asc === false) { // descending 
        if (order !== 0) {
          return order * -1; // descending 
        }
      }
      return order;
      ////
      /*
      if (a[sortedColumnKey] && b[sortedColumnKey]) {
        // if (sortingState[sortedColumnKey] && sortingState[sortedColumnKey].asc === true) {
        if (sortingState[sortedColumnKey] && typeof sortingState[sortedColumnKey].asc === 'boolean') {
          // ascending
          if (a[sortedColumnKey] < b[sortedColumnKey]) {
            order = -1;
            // return -1;
          }
          if (a[sortedColumnKey] > b[sortedColumnKey]) {
            order = 1;
            // return 1;
          }
        }
        if (sortingState[sortedColumnKey].asc === false) { // descending 
          if (order !== 0) {
            return order * -1; // descending 
          }
        }
        return order;
      }
      // a must be equal to b
      return 0;
      */
    });
  }
  //
  const _getColumnSortedState = (k, cellBlu) => { // k is column key or cell key
    let _column_sorted_state = {
      sortable: false,
      sorted: false,
      asc: null, // order ascending or descending
    };
    if (cellBlu?.sortable === true) {
      _column_sorted_state.sortable = true;
    }
    if (sortedColumnKey && sortedColumnKey === k) {
      _column_sorted_state.sorted = true;
    }
    if (sortingState[k] && sortingState[k].asc === true) {
      _column_sorted_state.asc = true;
    }
    if (sortingState[k] && sortingState[k].asc === false) {
      _column_sorted_state.asc = false;
    }
    return _column_sorted_state;
  };


  // ----- PAGINATION FILTERING
  // let sortedData = initialRowsData;
  let currentPageData = sortedData;
  const size = sortedData.length;
  const page_no = pageNo;
  const prev_page_no = pagination_utils.prev_page_no_get(size, perPage, page_no);
  const next_page_no = pagination_utils.next_page_no_get(size, perPage, page_no);
  const pages_count = pagination_utils.pages_count_get(size, perPage);
  if (perPage > 0) { // CASE pagination enabled
    currentPageData = sortedData.filter((item, item_index) => {
      return pagination_utils.is_item_in_page(perPage, page_no, item_index);
    });
  }
  const visibleRowsData = currentPageData; // currentPageData rows are also visible rows


  // -----
  //
  const _handleClickSelectAllRows = (singular) => {
    if (singular === true) { // singular
      if (blueprintTable.showSelectableSingular === true) {
        setState(state => {
          return {
            ...state,
            selectedRowSingularKey: false,
          };
        });
      }
    } else { // multiple
      if (blueprintTable.showSelectable === true) {
        setState(state => {
          let selectedRowKeys = [];
          let selectedAllRows = true; // null or false become true
          if (state.selectedAllRows === true) { // CASE UNSELECT ALL
            selectedAllRows = false; // true become false
            //
            if (blueprintGeneral.selectAllSelectOnlyVisible !== true) { // CASE UNSELECT all visile and invisible
              selectedRowKeys = []; // empty all selected
            } else { // CASE UNSELECT all only visible
              //
              let updated_selectedRowKeys_all = [];
              updated_selectedRowKeys_all = [...state.selectedRowKeys]; // preserve already selected rows
              //
              // STEP make visibleRowsKeys
              const visibleRowsKeys = [];
              visibleRowsData.forEach((row, row_index) => {
                if (typeof blueprintRow.rowKeyExtractorCb === 'function') {
                  const row_key = blueprintRow.rowKeyExtractorCb(row, row_index);
                  if (js_utils.is_number_or_string_not_empty(row_key)) { // valid keys only
                    if (visibleRowsKeys.includes(row_key)) { // CASE already included
                      // do nothing
                    } else { // CASE not included
                      visibleRowsKeys.push(row_key);
                    }
                  }
                } else {
                  // ERROR
                }
              });
              //
              // STEP filter out visible keys form selected keys
              const updated_selectedRowKeys_all_2 = updated_selectedRowKeys_all.filter((row_key) => {
                if (visibleRowsKeys.includes(row_key)) { // CASE visible row
                  return false; // UNSELECT visible row
                } else { // CASE not visible row
                  return true; // preserve selected invisible rows
                }
              });
              selectedRowKeys = updated_selectedRowKeys_all_2;
              //
            }
          } else { // CASE SELECT ALL
            selectedAllRows = true; // null or false become true
            //
            let updated_selectedRowKeys_all = [];
            updated_selectedRowKeys_all = [...state.selectedRowKeys]; // preserve already selected rows
            let rowsDataForSelectAll = initialRowsData;
            if (blueprintGeneral.selectAllSelectOnlyVisible !== true) { // CASE select all visile and invisible
              rowsDataForSelectAll = initialRowsData;
            } else { // CASE select all only visible
              rowsDataForSelectAll = visibleRowsData; // filtered rows are also visible rows
            }
            rowsDataForSelectAll.forEach((row, row_index) => {
              if (typeof blueprintRow.rowKeyExtractorCb === 'function') {
                const row_key = blueprintRow.rowKeyExtractorCb(row, row_index);
                if (js_utils.is_number_or_string_not_empty(row_key)) { // valid keys only
                  if (updated_selectedRowKeys_all.includes(row_key)) { // CASE already included
                    // do nothing
                  } else { // CASE not selected
                    updated_selectedRowKeys_all.push(row_key);
                  }
                }
              } else {
                // ERROR
              }
            });
            selectedRowKeys = updated_selectedRowKeys_all;
            //
          }
          return {
            ...state,
            selectedAllRows,
            selectedRowKeys,
          };
        });
      }
    }
  };
  //
  const _handleClickSelectRow = (row, row_key, singular) => {
    if (js_utils.is_number_or_string_not_empty(row_key)) { // valid keys only
      if (singular === true) { // singular
        if (blueprintTable.showSelectableSingular === true) {
          setState(state => {
            return {
              ...state,
              selectedRowSingularKey: row_key,
            };
          });
        }
      } else { // multiple
        if (blueprintTable.showSelectable === true) {
          setState(state => {
            let updated_selectedRowKeys = [];
            let bingo = false;
            state.selectedRowKeys.forEach((_row_key) => {
              if (_row_key === row_key) { // remove from selection
                bingo = true;
              } else { // all other stay
                updated_selectedRowKeys.push(_row_key);
              }
            });
            if (bingo === false) { // add to selection
              updated_selectedRowKeys.push(row_key);
            }
            return {
              ...state,
              selectedRowKeys: updated_selectedRowKeys,
              selectedAllRows: null, // also reset selectedAllRows
            };
          });
        }
      }
    }
  };
  //
  const _isRowSelected = (row, row_key, singular) => {
    if (singular === true) { // singular
      if (selectedRowSingularKey !== false && selectedRowSingularKey === row_key) {
        return true;
      }
    } else { // multiple
      /*
      if (selectedAllRows === true) {
        return true;
      }
      */
      // console.log(selectedRowKeys);
      return selectedRowKeys.includes(row_key);
      /*
      if (selectedRowKeys.includes(row_key)) {
        return true;
      } else {
        return false;
      }
      */
    }
  };


  //
  useEffect(() => {
    if (typeof cbOnSelectionChange === 'function') { // multiple
      // sending all rows regardles if they visible or not
      if (selectedAllRows === true) {
        /*
        // cbOnSelectionChange(true); // TODO
        const _selectedRowKeys_all_for_sending = initialRowsData.map((row, row_index) => {
          if (typeof blueprintRow.rowKeyExtractorCb === 'function') {
            return rowKeyExtractorCb(row, row_index);
          } else {
            return null; // ERROR
          }
        });
        cbOnSelectionChange(_selectedRowKeys_all_for_sending); //
        */
        cbOnSelectionChange(selectedRowKeys);
      } else {
        cbOnSelectionChange(selectedRowKeys);
      }
    }
    if (typeof cbOnSelectionChangeSingular === 'function') { // singular
      if (selectedRowSingularKey === false) {
        cbOnSelectionChangeSingular(null); // none selected
      } else {
        cbOnSelectionChangeSingular(selectedRowSingularKey); // selected singular row
      }
    }
  }, [selectedRowKeys, selectedAllRows, selectedRowSingularKey]);


  //
  useEffect(() => {
    if (fetching === true) { // RESET selected rows on fething
      setState(state => {
        return {
          ...state,
          selectedRowKeys: [],
          selectedAllRows: null, // null or true (all selected) or false (none selected)
          selectedRowSingularKey: null,
        };
      });
    }
  }, [fetching]);


  //
  const _handleChangePerPage = (perPage) => {
    setState(state => {
      let _perPage = '';
      if (Number?.parseInt(perPage) > 0) {
        _perPage = Number.parseInt(perPage);
      }
      return {
        ...state,
        perPage: _perPage,
        pageNo: 1, // also reset pageNo
      };
    });
  };
  //
  const _handleClickPagePrev = () => {
    setState(state => {
      let prevPageNo = 1;
      if ((state.pageNo - 1) > 0) {
        prevPageNo = (state.pageNo - 1);
      }
      return {
        ...state,
        pageNo: prevPageNo,
      };
    });
  };
  //
  const _handleClickPageNext = () => {
    setState(state => {
      return {
        ...state,
        pageNo: state.pageNo + 1,
      };
    });
  };


  // ---------- DATA IS READY
  // const rowsArr = sortedData;
  const rowsArr = currentPageData;
  const selectedAllRowsChecked = selectedAllRows;
  //
  return {
    fetching,
    dataError,
    blueprintError,

    blueprintGeneral,
    blueprintTable,
    blueprintColumns,
    blueprintRow,

    _getColumnSortedState,
    _handleClick_th_sort,
    _handleChangeColumnFilterString,
    selectedAllRowsChecked,
    selectedRowsCount: selectedRowKeys.length,
    _isRowSelected,
    _handleClickSelectRow,
    _handleClickSelectAllRows,
    _isColumnRendered,
    _handleClickShowMoreColumns,
    _is_column_index_first_in_special_more_section,

    perPage,
    pageNo,
    prev_page_no,
    next_page_no,
    pages_count,
    _handleChangePerPage,
    _handleClickPagePrev,
    _handleClickPageNext,

    rowsArr,
  };
};